const SUPPORTED_LANGUAGES = ["en", "vi"] as const

type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

const LANGUAGE_PARAM_KEYS = ["lang", "locale", "language"] as const

function normalizeLanguageParam(
  value: string | null
): SupportedLanguage | null {
  if (!value) return null

  const normalized = value.trim().toLowerCase().split("-")[0]
  if (normalized === "en" || normalized === "vi") {
    return normalized
  }

  return null
}

function parseLanguageFromSearchParams(
  searchParams: URLSearchParams
): SupportedLanguage | null {
  for (const key of LANGUAGE_PARAM_KEYS) {
    const language = normalizeLanguageParam(searchParams.get(key))
    if (language) return language
  }

  return null
}

export {
  LANGUAGE_PARAM_KEYS,
  SUPPORTED_LANGUAGES,
  normalizeLanguageParam,
  parseLanguageFromSearchParams,
}
export type { SupportedLanguage }
